export default "/images/vendor/@coreui/icons/svg/flag/cif-mt.svg?9060669ce9bd5c8281951b0b7faa6379";